import { Button } from "@mui/material";
import { GridCellParams } from "@mui/x-data-grid";
import { useUpdateRecord } from "../../../api/useUpdateRecord";
import { getStore } from "../../../store/store";

type DisassociateOrderButtonProps = {
    params: GridCellParams;
};

export const DisassociateOrderButton = ({ params }: DisassociateOrderButtonProps) => {
    const updateRecord = useUpdateRecord({ queryInvalidatePrefix: "orders_payments-items" });
    const { notifications } = getStore();

    const handleDisassociate = async (event: React.MouseEvent) => {
        event.stopPropagation();

        try {
            await updateRecord.mutateAsync({
                id: params.row.id,
                entity: "orders_payments",
                data: {
                    connected_bank_transaction_id: null,
                },
            });

            notifications.setNotification({
                isOpen: true,
                message: "Compra desassociada com sucesso",
                severity: "success",
            });
        } catch (error) {
            notifications.setNotification({
                isOpen: true,
                message: "Não foi possível desassociar a compra",
                severity: "error",
            });
        }
    };

    return (
        <Button
            variant="outlined"
            color="error"
            size="small"
            onClick={handleDisassociate}
            disabled={updateRecord.isLoading}
        >
            Desassociar
        </Button>
    );
};

